import { cn } from '../../lib/utils'

function Modal({
  children,
  LogoComponent,
  className,
}: {
  children: React.ReactNode
  LogoComponent: React.ComponentType
  className?: string
}) {
  return (
    <div className="w-full h-full">
      <div className="flex items-start md:items-center justify-center py-16 md:py-12 min-h-screen">
        <div
          className={cn(
            'md:bg-white grid w-full gap-6 md:w-[425px] md:rounded-3xl p-6 md:mx-auto md:p-[64px]',
            'md:shadow-[0px_17px_56.8px_color-mix(in_srgb,var(--foreground)_11%,transparent),43px_62px_138.3px_color-mix(in_srgb,var(--main)_24%,transparent)]',
            className,
          )}
        >
          <div className="grid gap-2 justify-center items-center">
            <div className="rounded-[15px] md:shadow-[4px_6px_10.2px_color-mix(in_srgb,var(--main)_65%,transparent),0px_13px_18.9px_color-mix(in_srgb,var(--main)_23%,transparent)]">
              <LogoComponent />
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

export { Modal }
